import PropTypes from 'prop-types';

const Help = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 46 45" {...props}>
    <path
      fill={colour}
      d="M29.777 5.259c1.646.003 2.703 1.049 2.703 2.737.041 2.737-2.401 3.381-5.929 3.381h-2.254l.187 6.99h5.635l.188-2.818c4.924-.04 8.412-2.67 8.412-7.513C38.719 2.817 35.07 0 29.851 0c-5.93 0-9.096 3.609-8.976 8.117h6.051c0-1.729 1.017-2.855 2.851-2.858Zm-2.408 15.885c-2.294 0-3.837 1.543-3.837 3.528 0 1.986 1.543 3.462 3.837 3.462 2.294 0 3.797-1.543 3.797-3.462 0-1.918-1.543-3.528-3.797-3.528Zm-7.661 3.528c0 1.919-1.543 3.462-3.797 3.462-2.294 0-3.836-1.476-3.836-3.462 0-1.985 1.583-3.528 3.836-3.528 2.254 0 3.797 1.61 3.797 3.528ZM41.12 7.875v.161c0 1.382-.228 2.643-.657 3.77a20.04 20.04 0 0 1 2.455 9.646c0 5.555-2.254 10.586-5.89 14.235-2.266 2.267-5.076 1.389-8.219.406-1.899-.593-3.919-1.225-6.015-1.225-2.096 0-4.114.632-6.011 1.225-3.141.983-5.948 1.861-8.224-.406A20.068 20.068 0 0 1 2.67 21.452c0-6.319 2.911-11.953 7.459-15.643l-.134-3.233C3.971 6.695 0 13.617 0 21.466c0 12.598 10.21 22.807 22.807 22.807 12.598 0 22.808-10.209 22.808-22.807 0-5.098-1.664-9.794-4.495-13.591ZM19.292.523l-.751 17.991h-5.447L12.343.523h6.949Z"
    ></path>
  </svg>
);

Help.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default Help;
